
export type CompareOpSpec = {
	op: string;
	label: { en: string; fr: string };
};

export const COMPARE_REGISTRY: readonly CompareOpSpec[] = [
	{ op: ">",  label: { en: "Greater than (a > b)",     fr: "Supérieur (a > b)"     } },
	{ op: ">=", label: { en: "Greater or equal (a ≥ b)", fr: "Supérieur ou égal (a ≥ b)" } },
	{ op: "==", label: { en: "Equal (a == b)",           fr: "Égal (a == b)"          } },
	{ op: "!=", label: { en: "Not equal (a ≠ b)",        fr: "Différent (a ≠ b)"      } },
	{ op: "<=", label: { en: "Less or equal (a ≤ b)",    fr: "Inférieur ou égal (a ≤ b)" } },
	{ op: "<",  label: { en: "Less than (a < b)",        fr: "Inférieur (a < b)"      } },
];

const COMPARE_OP_BY_NAME: Record<string, CompareOpSpec> = Object.fromEntries(
	COMPARE_REGISTRY.map((c) => [c.op, c]),
);

export const COMPARE_OPS: readonly string[] = COMPARE_REGISTRY.map((c) => c.op);

export const isValidCompareOp = (op: string): boolean => op in COMPARE_OP_BY_NAME;
